export default __webpack_public_path__ + "static/media/elfCentralIcon.47b7f436.svg";